<template>
  <div class="article-info">
    <div class="main-container">

      <div class="flex-width" style="margin-top: 20px" v-if="breadcrumbList && breadcrumbList.length">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <span class="el-breadcrumb__inner" style="float: left;margin-right: 6px">
            <i class="iconfont icon-weizhi"></i>
            当前位置：
          </span>
          <el-breadcrumb-item v-for="(item, i) in breadcrumbList"
                              :key="i"
                              :to="item.path ? { path: item.path } : null">{{item.title}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="module flex-width">
        <el-row :gutter="40" style="width: 100%">
          <el-col :span="18">
            <div v-if="!formDetail.id" class="no-data"><i class="iconfont icon-zanwushuju"></i>{{$t('common.noData')}}</div>
            <div class="data-info"
                 v-else
                 v-loading="loadSate">
              <div class="data-title">{{formDetail.title}}</div>

              <div class="data-author"
                    v-if="formDetail.author">{{formDetail.author}}
                <div class="data-date">{{formDetail.createTime}}</div>
              </div>
              <!-- 标签 -->
              <div class="labels" v-if="formDetail.tags">
                <span class="label">标签：</span>
                <span>
                  <el-tag v-for="item in formDetail.tags.split(',')"
                          :key="item"
                          effect="dark">
                    {{ item }}
                  </el-tag>
                </span>
              </div>
              <!-- 文章正文 -->
              <div class="article-content"
                    v-html="formDetail.content">
              </div>
            </div>
          </el-col>

          <el-col :span="6" class="right">
            <sidebar></sidebar>
          </el-col>
        </el-row>
      </div>

    </div>
  </div>
</template>

<script>
import {enumeration} from '@/assets/js/enumeration.js'
import sidebar from './components/sidebar'

export default {
  name: 'article-info',
  components: {sidebar},
  props: {
    path: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: '/contentManagement/get'
    },
    title: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      loadSate: false,
      formDetail: {},
      breadcrumbList: [
      ],
    }
  },
  mounted () {
    let id = this.$route.query.id
    if (id) {
      this.viewExplain(id)
    }
    
    if (this.title) { // 非内容类型的文章
      this.breadcrumbList.push({title: this.title, path: this.path})
      this.breadcrumbList.push({title: this.title + '详情'})
    } 
  },
  methods: {
    viewExplain (id) {
      this.$http({
        url: this.$http.adornUrl(window.SITE_CONFIG.basContextPath + this.url),
        method: 'get',
        params: {id}
      }).then(res => {
        if (res.data && res.data.code === 'C0000') {
          this.formDetail = res.data.result ? res.data.result : {}

          if (this.title) return // 已经有传入的导航信息不走以下逻辑-研究员专栏

          let type = enumeration.contentTypes.find(item => item.value === this.formDetail.contentType)
          if (type) {
            this.breadcrumbList.push({title: type.label, path: type.path})
            this.breadcrumbList.push({title: type.label + '详情'})
          }
        } else {
          this.$message.error(res.data.message)
          this.editorHtml = ''
        }
      }).catch(() => {
        this.editorHtml = ''
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.article-info{
  .right{
    padding: 10px 0;
  }
  .data-info {
    min-height: 300px;
    .data-title {
      font-size: 26px;
      border-bottom: 1px dotted #cbdbef;
      padding-bottom: 14px;
      color: #000;
    }

    .data-author {
      padding: 10px 0;
      font-size: 12px;
      position: relative;
      color: #8a94a8;
      .data-date {
        position: absolute;
        right: 0;
        top: 14px;
      }
    }
    .article-content{
      margin-top: 20px;
    }
    .labels {
      padding-top: 6px;
      .label {
        display: inline-block;
        width: 60px;
        color: #888;
        font-size: 12px;
      }
      .el-tag {
        height: 25px;
        line-height: 23px;
        margin-right: 10px;
      }
    }
  }
  .main-container {
    margin: auto;
    max-width: 1920px;
    .module{
      padding: 20px;
    }
    .flex-width{
      max-width: 1200px;
      margin: auto;
    }
    .flex-row{
      display: flex;
      justify-content: space-between;
      padding: 20px 0;
      font-size: 16px;
      line-height: 24px;
      border-bottom: 1px solid #eee;
      .content{
        flex: 1;
        padding-left: 20px;
        color: #303133;
        .title{
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: normal;
          font-size: 18px;
          color: #000;
        }
        .label{
          margin-top: 12px;
          span{
            margin-right: 12px;
            border: 1px solid #888;
            border-radius: 10px;
            padding: 2px 10px;
            font-size: 14px;
          }
        }
        .text{
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: normal;
        }
        .autor{
          color: #909399;
          margin: 10px 0;
        }
        .data{
          border: 1px solid #888;
          border-radius: 10px;
          padding: 1px 6px;
          font-size: 12px; 
          margin-left: 10px;
          vertical-align: 0.15em;
          i{
            margin-right: 6px;
          }
        }
      }
      .picture{
        width: 160px;
        height: 120px;
        img{
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/info.vue